import { render, staticRenderFns } from "./TabStaticCo2.vue?vue&type=template&id=48d71c07"
import script from "./TabStaticCo2.vue?vue&type=script&lang=js"
export * from "./TabStaticCo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports